var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessageBubble = function SvgMessageBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06016 18.2914C9.0598 17.8486 8.75041 17.4605 8.31113 17.3664C6.67269 17.0155 5.22207 16.0707 4.2387 14.7139C3.25534 13.3572 2.8088 11.6846 2.98511 10.0183C3.16141 8.35203 3.94809 6.8099 5.1936 5.68902C6.43907 4.56818 8.05523 3.94785 9.73077 3.94751C9.73083 3.94751 9.73089 3.94751 9.73094 3.94751L14.2321 3.94752L14.2365 3.9475C15.1301 3.94336 16.0157 4.1158 16.8425 4.4549C17.6693 4.79401 18.4209 5.2931 19.0543 5.92352C19.6876 6.55395 20.1902 7.30328 20.5331 8.12848C20.876 8.95368 21.0526 9.8385 21.0526 10.7321C21.0526 11.6258 20.876 12.5106 20.5331 13.3358C20.1902 14.161 19.6876 14.9103 19.0543 15.5407C18.4209 16.1712 17.6693 16.6702 16.8425 17.0094C16.0157 17.3485 15.1301 17.5209 14.2365 17.5168V17.5167H14.2321H13.4268C13.0941 17.5167 12.7857 17.6913 12.6144 17.9767C11.7668 19.3894 10.3366 20.3519 9.18875 20.9317C9.14178 20.955 9.08904 20.9642 9.03693 20.9581C8.98452 20.952 8.93504 20.9307 8.89456 20.8969C8.85408 20.863 8.82438 20.8181 8.80909 20.7676C8.79381 20.7171 8.79361 20.6633 8.80852 20.6127C9.0308 19.86 9.11596 19.0738 9.06016 18.2914Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.89486,
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-bubble.1726fdb8.svg";
export { ForwardRef as ReactComponent };